/**
 * 通知模板变量配置
 *
 * 定义不同通知类型可用的模板变量
 * 变量描述会自动从 columns.ts 的 COLUMN_NAMES 配置中获取
 */

// 商标监控通知可用变量
export const TRADEMARK_VARIABLES = [
  'name',
  'application_no',
  'registration_no',
  'status',
  'nation',
  'owner_name',
  'primary_class',
  'sub_class',
  'image',
  'application_at',
  'status_updated_at',
  'due_at',
  'next_update_at',
  'approve_at',
  'attorney_name',
  'attorney_email',
];

// 订单过期通知可用变量
export const ORDER_VARIABLES = [

  // 所有业务通用字段
  'nation',
  'contact_name',
  'order_no',
  'case_no',
  'applicant_name',
  'applicant_address',
  'applicant_name_en',
  'applicant_address_en',
  'application_at',
  'created_at',
  'updated_at',
  'due_at',
  'approve_at',
  'payment_at',
  'payment_status',
  'next_status',
  'status',
  'service',

  // 部分业务通用字段
  'registration_no',
  'company_name',
  'cancellation_reason',
  'sub_service',

  // 商标业务
  'trademark_name',
  'trademark_image',
  'trademark_status',
  'application_no',
  'primary_class',
  'sub_class',

  // 专利业务
  'patent_name',
  'entity_type',
  'inventor_name',
  'inventor_address',
  'inventor_name_en',
  'inventor_address_en',
  'patent_type',
  'review_type',
  'rejection_reason',
  'postpone_times',

  // 版权业务
  'work_name',
  'opened_area',
  'opened_at',
  'open_status',
  'opened_type',
  'application_type',
  'application_category',
  'work_inspiration',

  // 公司业务
  'company_no',
  'company_address',
  'company_type',
  'legal_representative',
  'include_vat_no',
  'include_bank_account',
  'include_foreign_directors',
  'annual_inspection_times',
  'account_bank',
  'change_items',

  // 二维码业务
  'quantity',
  'validity_period',
  'renewal_period',
  'quantity_original',
  'quantity_increase',

  // 其他
  'service_name',
];

// 专利缴费通知可用变量
export const PATENT_PAYMENT_VARIABLES = [
  'order_no',
  'year',
  'started_at',
  'due_at',
  'grace_at',
  'payment_at',
  'status',
  'remark',
];
